export const convertToLocalCurrency = (val) => {
  if (val)
    return val.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  return '0.00'
}
